// extracted by mini-css-extract-plugin
export var container = "About-module--container--3IAL4";